import { ShieldOff } from "lucide-react";
import { useHasPermission } from "./useHasPermission";

interface RBACRouteProps {
  permission: string;
  children: React.ReactNode;
}

const NoPermission = () => (
  <div className="flex flex-col items-center justify-center h-64 gap-3 text-muted-foreground">
    <ShieldOff className="w-10 h-10 opacity-40" />
    <p className="text-sm font-medium">You don't have permission to access this page.</p>
  </div>
);

/**
 * Route wrapper that protects children with RBAC. Renders an inline
 * access-denied message instead of redirecting — keeps the URL stable
 * so the user sees WHY they're blocked.
 */
export function RBACRoute({ permission, children }: RBACRouteProps) {
  const { hasPermission, isLoading } = useHasPermission(permission);

  if (isLoading) return null;
  if (!hasPermission) return <NoPermission />;

  return <>{children}</>;
}
